const mapResponseData = (response) => {
    const features = response.data.areas.features.map((feature) => {
        return {
            id: feature.properties.id,
            label: feature.properties.name,
            admin_level: feature.properties.admin_level,
            geometry: {
                type: feature.geometry.type,
                coordinates: feature.geometry.coordinates,
            },
            state: feature.properties.mark,
            area_id: feature.properties.id,
            power_kw_min: feature.properties.power_kw_min,
            power_kw_avg: feature.properties.power_kw_avg,
            power_kw_max: feature.properties.power_kw_max,
        }
    })

    return features;
}   

export default mapResponseData;